import { useEffect, useRef } from 'react';

interface CompressedImageData {
	compressedTagName?: string | null;
	originalId?: string | null;
	variants?: unknown;
}

export function useApplyUploadOnce(
	imageData: CompressedImageData | null | undefined,
	expectedTag: string,
	onApply: (originalId: string, variants: unknown) => void
) {
	const lastAppliedIdRef = useRef<string | null>(null);

	useEffect(() => {
		if (imageData?.compressedTagName !== expectedTag) return;
		if (!imageData?.originalId || !imageData?.variants) return;
		if (lastAppliedIdRef.current === imageData.originalId) return;

		lastAppliedIdRef.current = imageData.originalId;
		onApply(imageData.originalId, imageData.variants);
	}, [imageData, expectedTag, onApply]);

	return lastAppliedIdRef;
}
